import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const TOKENS = {
    radius: 20,
    cardBg: "#FFFFFF",
    body: "#333333",
    title: "#111111",
};

export default function ProductDescriptionCard({
                                                   title = "ΠΕΡΙΓΡΑΦΗ",
                                                   text = "",
                                               }) {


    return (
        <Box
            sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                boxSizing: "border-box",
                p: { xs: 2, md: 3 },
                display: "grid",
                gridTemplateRows: "auto auto",
                rowGap: { xs: 1.5, md: 1.5 },
                minHeight: { xs: "auto", md: 150 },
            }}
        >
            <Typography
                sx={{
                    fontSize: { xs: 13, md: 15 },
                    fontWeight: 800,
                    letterSpacing: 0.3,
                    color: TOKENS.title,
                    textTransform: "uppercase",
                }}
            >
                {title}
            </Typography>

            <Typography
                component="div"
                sx={{
                    color: TOKENS.body,
                    fontSize: { xs: 14, md: 15 },
                    lineHeight: { xs: 1.6, md: 1.7 },
                    overflowWrap: "anywhere",
                    wordBreak: "break-word",
                    hyphens: "auto",
                    "& ul": {
                        m: 0,
                        pl: "1.2em",
                        listStyleType: "disc",
                        listStylePosition: "outside",
                    },
                    "& li": {
                        margin: 0,
                        padding: 0,
                        mb: 0.5,
                    },
                }}
            >
                {text && (
                    <div  style={{whiteSpace: "pre-line"}} dangerouslySetInnerHTML={{__html: text}}/>
                )}

            </Typography>
        </Box>
    );
}
